/*
  Image loading shimmer.

  Marks every image in the page content that has not finished loading with
  .sm-pending, and takes the class off the moment it loads (or fails). The
  stylesheet runs a shimmer across the image's box while the class is on, so
  a slow image reads as loading instead of an empty tile. Images that are
  already in the cache never get the class. Cards added later (carousels,
  recommendations, episode grids) are picked up as they arrive.
*/
(function () {
  const root = document.getElementById('MainContent');
  if (!root) return;

  function mark(img) {
    if (img.dataset.smSkel) return;
    img.dataset.smSkel = '';
    if (img.complete && img.naturalWidth) return;
    img.classList.add('sm-pending');
    const done = () => img.classList.remove('sm-pending');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  function scan(node) {
    if (node.tagName === 'IMG') mark(node);
    if (node.querySelectorAll) node.querySelectorAll('img').forEach(mark);
  }

  scan(root);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && scan(n)));
  }).observe(root, { childList: true, subtree: true });
})();
